export default {
  setCompra(state, payload) {
    state.compra = payload;
  },
  setEtapa(state, payload) {
    state.compra.etapa = payload;
  },
};
